<template>
  <v-row>
    <v-overlay :value="loadingContrat" :absolute="true" :opacity="1"
      >Chargement ... Veuillez patienter
      <v-progress-linear color="blue" indeterminate rounded height="25">
      </v-progress-linear>
    </v-overlay>
    <v-col
      v-if="dateContrat == null && demandes.length == 0 && !demandeDisabled"
    ></v-col>
    <v-col
      v-else-if="dateContrat == ''"
      class="d-flex warning justify-center font-weight-bold"
      >Vous ne pouvez pas saisir de demande car votre statut ne le permet
      pas.</v-col
    >

    <v-col
      v-else-if="minimumDate().getTime() > Date.now() && dernierEtat()"
      class="d-flex warning justify-center font-weight-bold"
    >
      Vous ne pouvez pas saisir de demande car votre dernière demande acceptée
      date de ce mois.
    </v-col>
    <v-col
      v-else-if="demandeDisabled"
      class="d-flex warning justify-center font-weight-bold"
    >
      Vous ne pouvez pas saisir de demande car vous avez une demande en cours de
      traitement.
    </v-col>
    <v-col
      v-else-if="dateDerniereDemande()"
      class="d-flex warning justify-center font-weight-bold"
    >
      Vous ne pouvez saisir qu'une seule demande par mois.
    </v-col>
    <v-col
      class="text-center"
      v-else-if="demandes.length > 0 && demandeValid()"
    >
      <v-btn color="warning" @click="modification"
        >Modification de la demande</v-btn
      >&nbsp;<v-btn color="error" @click="suppressionDemande"
        >Suppression de la demande</v-btn
      >
    </v-col>
    <v-col
      class="text-center"
      v-else-if="!demandeDisabled && !(minimumDate().getTime() > Date.now())"
    >
      <v-btn
        color="success"
        align-center
        @click="formOn"
        :disabled="demandeDisabled || minimumDate().getTime() > Date.now()"
      >
        Faire une demande
      </v-btn>
    </v-col>
    <v-col cols="12" md="12">
      <v-data-table
        :headers="headers"
        :items="demandes"
        class="elevation-1"
        pagination.sync="pagination"
        loading="true"
        search
        v-if="demandes.length != 0"
      >
        <template v-slot:[`item.typeSouscription`]="{ item }">
          <v-col>{{
            refTypeSouscription[item.typeSouscription - 1].name
          }}</v-col>
        </template>
        <template v-slot:[`item.debutContrat`]="{ item }">
          <v-col>{{
            item.debutContrat
              ? new Date(item.debutContrat).toLocaleString("fr-FR", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : ""
          }}</v-col>
        </template>
        <template v-slot:[`item.cotisationParEmployeur`]="{ item }">
          <v-col v-if="item.cotisationParEmployeur == true">Oui</v-col>
          <v-col v-else-if="item.cotisationParEmployeur == false">Non</v-col>
        </template>
        <template v-slot:[`item.nameFile`]="{ item }">
          <v-btn
            v-if="item.nameFile != null"
            icon
            color="grey"
            @click="afficherPDF(item)"
            ><v-icon>mdi-book-open-variant</v-icon></v-btn
          >
        </template>
        <template v-slot:[`item.validation`]="{ item }">
          <v-chip v-if="item.validation == null" color="warning"
            >en cours</v-chip
          >
          <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
          <v-chip v-else-if="item.validation == 1" color="success"
            >accepté</v-chip
          >
        </template>
        <template v-slot:[`item.etat`]="{ item }">
          <div class="text-center font-weight-bold">
            <v-chip color="grey" v-if="item.etat != 'ANNULATION'">
              {{ item.etat }}
            </v-chip>
            <v-chip v-else color="error">{{ item.etat }}</v-chip>
          </div>
        </template>
        <template v-slot:[`item.messagerie`]="{ item }">
          <v-col>
            <v-badge
              :color="
                item.nombreMessagesUtilisateur <= 0 ? 'transparent' : 'primary'
              "
              :content="item.nombreMessagesUtilisateur"
            >
              <v-btn
                icon
                @click="lancerMessagerie(item)"
                :color="item.nombreMessagesUtilisateur > 0 ? 'red' : 'grey'"
                ><v-icon>chat</v-icon></v-btn
              >
            </v-badge>
          </v-col>
        </template>
        <template v-slot:[`item.messageRefus`]="{ item }">
          <v-tooltip
            bottom
            color="red"
            max-width="150px"
            v-if="item.messageRefus"
          >
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">{{ item.messageRefusPetit }}</span>
            </template>
            <span>{{ item.messageRefus }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-col>
    <template>
      <v-row>
        <v-dialog v-model="dialog" persistent>
          <BaseBlock
            title="Formulaire pour le remboursement partiel de la complémentaire santé"
          >
            <v-form
              v-model="valid"
              ref="form"
              lazy-validation
              :disabled="finForm"
            >
              <v-alert
                v-if="error.messages"
                border="left"
                type="error"
                elevation="2"
              >
                <template>
                  <span
                    v-for="(errorMessage, index) in error.messages"
                    :key="index"
                  >
                    {{ errorMessage }}
                    <br />
                  </span>
                </template>
              </v-alert>
              <v-row>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="formComplementaire.nomComplementaire"
                    label="Nom de la complémentaire santé"
                    :rules="[(value) => !!value || 'Champ requis.']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-radio-group
                    v-model="formComplementaire.typeSouscription"
                    :rules="[(value) => !!value || 'Champ requis.']"
                    required
                  >
                    Type de Souscription

                    <v-radio
                      v-for="type in refTypeSouscription"
                      :key="type.id"
                      :label="type.name"
                      :value="type.id"
                    ></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col
                  sm="4"
                  cols="12"
                  v-if="formComplementaire.typeSouscription == 2"
                >
                  <v-radio-group
                    v-model="formComplementaire.cotisationParEmployeur"
                    :rules="[(value) => !!value || 'Champ requis.']"
                    required
                  >
                    Cotisation par l'employeur du titulaire du contrat
                    <v-radio label="Oui" value="true"></v-radio>
                    <v-radio label="Non" value="false"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4">
                  <v-menu
                    v-model="showCalendarDebut"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="formatedDateDebut"
                        label="Date de début de contrat Complémentaire Santé"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        required
                        :rules="[(value) => !!value || 'Champ requis.']"
                        :messages="//'minimum: ' +
                        //minimumDate().toLocaleDateString() +', '+
                        'maximun: 01/04/2026'"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr-fr"
                      v-model="formComplementaire.debutContrat"
                      type="month"
                      :max="new Date(2026, 4, 1).toISOString().substring(0, 10)"
                      :min="minimumDate().toISOString().substring(0, 10)"
                      :disabled="minimumDate() > Date.now()"
                      @input="showCalendarDebut = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-file-input
                    label="Attestation de la complémentaire santé"
                    accept=".pdf, .png, .jpg, .jpeg"
                    v-model="formComplementaire.nameFile"
                    :rules="[
                      (value) => !!value || 'Champ requis.',
                      (value) =>
                        (!!value &&
                          /^.+\.(pdf|png|jpg|jpeg)$/.test(
                            value.name.toLowerCase()
                          )) ||
                        'Format incorrect. Formats acceptés : pdf, png, jpg, jpeg.',
                    ]"
                  >
                  </v-file-input>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <div class="text-center" v-if="!finForm">
                    <v-btn
                      class="mx-2"
                      :disabled="!valid"
                      color="success"
                      @click="validerFormComplementaire"
                      :loading="loading"
                    >
                      <v-icon left>mdi-magnify</v-icon>Valider
                    </v-btn>
                    <v-btn class="mx-2" @click="annuler" color="warning">
                      <v-icon left>mdi-refresh</v-icon>Effacer
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      color="info"
                      @click="fermerDialogDemande"
                      ><v-icon left>mdi-close</v-icon>fermer</v-btn
                    >
                  </div>
                  <div class="text-center" v-else>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </BaseBlock>
        </v-dialog>
      </v-row>
    </template>

    <v-col
      ><v-dialog v-model="dialogPDF" @click:outside="iframeSrc = null">
        <BaseBlock>
          <v-responsive height="500px"
            ><iframe
              height="100%"
              width="100%"
              :src="iframeSrc"
              title="document PDF"
            ></iframe></v-responsive
          ><br />
          <div class="text-center">
            <v-btn
              color="info"
              @click="
                iframeSrc = null;
                dialogPDF = false;
              "
              >fermer</v-btn
            >
          </div>
        </BaseBlock>
      </v-dialog></v-col
    >
    <v-col cols="12">
      <BaseBlock title="Information" v-if="messageInformation">
        <div v-html="messageInformation"></div>
      </BaseBlock>
    </v-col>

    <messagerie ref="messagerie" :temoinGestionnaire="false"></messagerie>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import moment from "moment";
import ApiFormComplementaireRepository from "@/repositories/ApiFormComplementaireRepository";
import ApiIndividuRepository from "@/repositories/ApiIndividuRepository";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import messagerie from "@/components/Messagerie.vue";

export default {
  name: "FormComplementaire",
  components: { BaseBlock, messagerie },
  extends: BaseForm,
  data() {
    return {
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Nom de la complémentaire Santé",
          value: "nomComplementaire",
          align: "start",
        },
        { text: "Type de souscription", value: "typeSouscription" },
        {
          text: "Cotisation par l'employeur ?",
          value: "cotisationParEmployeur",
        },
        { text: "Date d'effet", value: "debutContrat", dateType: "Date" },

        { text: "Fichier joint", value: "nameFile" },
        { text: "Etat", value: "etat", align: "center" },
        { text: "Statut", value: "validation" },
        { text: "Messagerie", value: "messagerie" },
        { text: "Message de refus", value: "messageRefus" },
      ],
      demandes: [],
      demandeDisabled: true,
      formComplementaire: {
        nomComplementaire: null,
        typeSouscription: null,
        cotisationParEmployeur: null,
        debutContrat: null,
        nameFile: null,
        validation: null,
        messageRefus: null,
        etat: null,
      },
      valid: true,
      refTypeSouscription: null,
      dialog: false,
      dialogPDF: false,
      showCalendarDebut: false,
      showCalendarFin: false,
      message: null,
      hasResultats: false,
      loading: false,
      iframeSrc: null,
      finForm: false,
      dateContrat: null,
      indexDemandeValide: null,
      formComplementaireLocal: {
        etat: null,
      },
      messageInformation: null,
      loadingContrat: true,
    };
  },
  computed: {
    formatedDateDebut: {
      get: function () {
        if (this.formComplementaire.debutContrat < "2022-01") {
          return "2022-01-01" ? moment("2022-01-01").format("DD/MM/YYYY") : "";
        }

        return this.formComplementaire.debutContrat
          ? moment(this.formComplementaire.debutContrat).format("DD/MM/YYYY")
          : "";
      },
      set: function (value) {
        this.value = value;
      },
    },
    file() {
      return this.formComplementaire.nameFile != null
        ? new File([], this.formComplementaire.nameFile)
        : new File([], null);
    },
    formatedDateFin() {
      return this.formComplementaire.finContrat
        ? moment(this.formComplementaire.finContrat).format("DD/MM/YYYY")
        : "";
    },
  },

  watch: {
    "formComplementaire.typeSouscription": function (val) {
      if (val == 1) {
        this.formComplementaire.cotisationParEmployeur = null;
      }
    },
    demandes: function () {
      this.demandes.forEach((demande) => {
        if (demande.messageRefus != null) {
          demande.messageRefusPetit = demande.messageRefus.substr(0, 20);
          return demande.messageRefusPetit + demande.messageRefus.length > 20
            ? "..."
            : "";
        }
        return null;
      });
    },
  },

  async created() {
    this.demandeDisabled = false;
    if (sessionStorage.formComplementaire) {
      this.formComplementaire = JSON.parse(sessionStorage.formComplementaire);
    }
  },
  async mounted() {
    this.refTypeSouscription =
      await ApiFormComplementaireRepository.getRefTypeSouscriptions();
    this.demandes = await ApiFormComplementaireRepository.getDemandes();
    this.verificationDemande();
    this.dateContrat = await ApiIndividuRepository.getDateContrat();
    console.log(this.dateContrat);
    this.messageInformation =
      await ApiRefMessageRepository.getMessageInformation();
    this.loadingContrat = false;
  },
  methods: {
    async validerFormComplementaire() {
      if (this.$refs.form.validate()) {
        this.$confirm(
          "<strong>ATTENTION, en validant ce dossier vous ne pourrez plus le modifier. " +
            "Cliquez sur 'Oui' pour confirmer votre demande ou sur 'Non' pour revenir à l'écran précédent.</strong>"
        ).then(async (reponse) => {
          if (reponse) {
            this.finForm = true;
            this.demandes = await ApiFormComplementaireRepository.getDemandes();
            this.verificationDemande();
            if (this.demandeDisabled) {
              this.$toast.warn(
                "Une demande a été effectuée entre temps, veuillez recharger la page."
              );
            } else {
              if (this.formComplementaire.debutContrat < "2022-01-01") {
                this.formComplementaire.debutContrat = "2022-01-01";
              } else if (this.formComplementaire.debutContrat.length < 8) {
                this.formComplementaire.debutContrat =
                  this.formComplementaire.debutContrat.concat("-01");
              }
              if (
                this.formComplementaireLocal.etat == "MODIFICATION" ||
                this.formComplementaireLocal.etat == "CREATION"
              ) {
                this.formComplementaire.etat = "MODIFICATION";
                this.formComplementaire.validation = null;
                this.formComplementaire.id = null;
                this.formComplementaire.lot = null;
              } else this.formComplementaire.etat = "CREATION";

              this.demandes.push(
                await ApiFormComplementaireRepository.saveDemande(
                  this.formComplementaire
                )
              );
              this.demandeDisabled = true;
            }
            this.finForm = false;
            this.dialog = false;
            this.$refs.form.reset();
            this.formComplementaire = Object.assign({});
          }
        });
      }
    },
    annuler() {
      this.$refs.form.reset();
      this.formComplementaire = Object.assign({});
    },
    formOn() {
      this.dialog = true;
    },
    fermerDialogDemande() {
      this.annuler();
      this.dialog = false;
    },
    async afficherPDF(item) {
      this.iframeSrc =
        await ApiFormComplementaireRepository.getDemandeFileAgent(item.id);
      this.dialogPDF = true;
    },
    minimumDate() {
      console.log(this.dateContrat);
      if (
        this.dateContrat != null &&
        this.dateContrat != undefined &&
        this.dateContrat != ""
      ) {
        console.log("mais non");
        const date = new Date(
          this.demandes
            .filter(
              (value) => value.validation == 1 && value.etat != "ANNULATION"
            )
            .map((value) => value.debutContrat)
            .reduce(
              (accumulateur, valeurCourante) =>
                accumulateur < valeurCourante ? valeurCourante : accumulateur,
              "2021-12-01"
            )
        );
        if (date.getTime() > new Date(this.dateContrat).getTime()) {
          return date.getMonth() == 11
            ? new Date(date.getFullYear() + 1, 0, 1, 12, 0, 0)
            : new Date(date.getFullYear(), date.getMonth() + 1, 1, 12, 0, 0);
        } else return new Date(this.dateContrat);
      }
      return new Date(2099, 0, 1);
    },
    dateDerniereDemande() {
      var date = this.demandes.filter((value) => value.validation == 1);
      if (date.length == 0) return false;
      date = new Date(
        date
          .map((value) => (value.etat != "ANNULATION" ? value.createAt : null))
          .reduce((accumulateur, valeurCourante) =>
            accumulateur > valeurCourante ? accumulateur : valeurCourante
          )
      );

      const dateMaintenant = new Date(Date.now());
      const month = dateMaintenant.getMonth();
      const moisProchain = new Date(
        dateMaintenant.getFullYear(),
        month + 1,
        1,
        0,
        0
      );
      return (
        date.getFullYear() == moisProchain.getFullYear() &&
        date.getMonth() == month
      );
    },
    verificationDemande() {
      if (this.demandes != [])
        if (
          this.demandes.length > 0 &&
          this.demandes[this.demandes.length - 1].validation == null
        )
          this.demandeDisabled = true;
    },
    modification() {
      this.demandes.forEach((element) =>
        element.validation == 1 && element.etat != "ANNULATION"
          ? (this.formComplementaireLocal = element)
          : ""
      );
      this.formOn();
      console.log("je suis sur la dev");
    },
    demandeValid() {
      var valid = false;
      for (var i = 0; i < this.demandes.length; i++) {
        if (
          this.demandes[i].validation == 1 &&
          this.demandes[i].etat != "ANNULATION"
        ) {
          this.indexDemandeValide = i;
          valid = true;
        }
        if (
          this.demandes[i].etat.includes("SUPPRESSION") &&
          this.demandes[i].validation == 1
        ) {
          valid = false;
          this.indexDemandeValide = null;
        }
      }
      return valid;
    },
    suppressionDemande() {
      this.$confirm(
        "<strong>Voulez-vous vraiment supprimer votre demande ?</strong>"
      ).then(async (reponse) => {
        if (reponse) {
          this.formComplementaire = Object.assign(
            {},
            this.demandes[this.indexDemandeValide]
          );
          this.formComplementaire.etat = "SUPPRESSION";
          this.formComplementaire.validation = null;
          this.formComplementaire.id = null;
          this.formComplementaire.lot = null;

          this.formComplementaire.nameFile = new File([], "aaaaa.pdf");
          this.demandes.push(
            await ApiFormComplementaireRepository.saveDemande(
              this.formComplementaire
            )
          );
          this.demandeDisabled = true;
        }
      });
    },
    dernierEtat() {
      let demandeAcceptées = this.demandes.filter(
        (element) => element.validation == 1
      );
      console.log(demandeAcceptées);
      return demandeAcceptées[demandeAcceptées.length - 1].etat == "CREATION";
    },
    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
